import { FileText } from 'lucide-react';

const toHref = (url) => (/^https?:\/\//i.test(url) ? url : `https://${url}`);

export const ExampleLinkIcon = ({ url, testId, label = 'Ver ejemplo de publicación', emptyLabel = 'Sin ejemplo de publicación' }) => {
  const clean = (url || '').trim();
  if (!clean) {
    return (
      <span
        className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-slate-100 text-slate-300 cursor-not-allowed"
        title={emptyLabel}
        aria-disabled="true"
        data-testid={`${testId}-disabled`}
      >
        <FileText className="h-3 w-3" />
      </span>
    );
  }
  return (
    <a
      href={toHref(clean)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-emerald-100 text-emerald-700 hover:bg-emerald-200 transition-colors"
      title={label}
      data-testid={testId}
    >
      <FileText className="h-3 w-3" />
    </a>
  );
};

export default ExampleLinkIcon;
